module.exports = __webpack_public_path__ + "static/media/question.12993739.svg";